import QuoteFormTab from "./QuoteFormTab";
import { Container } from "@mui/material";
import QuoteDesc from "./QuoteDesc";

export default function GetQuote() {
  const content = (
    <Container
      sx={{
        minHeight: "100vh",
        width: "100vw",
        px: "0.5rem",
      }}
    >
      {/* company quote description  */}
      <QuoteDesc />
      {/* business and individual quote form */}
      <QuoteFormTab />
    </Container>
  );

  return content;
}
